import { FormHelperText as a, FormLabel as p } from "@mui/material";
import { styled as o, css as r } from "./styled2.mjs";
const n = o(a)`
	${({ theme: t, $hasError: e, $disabled: l }) => l ? r`
				color: ${e ? t.palette.error.main30 : t.palette.text.disabled};
			` : r`
			color: ${e ? t.palette.error.main : t.palette.text.secondary};
		`};
`, c = o(p)`
	color: ${({ theme: t }) => t.palette.text.secondary} !important;
`;
export {
  c as StyledRadioGroupLabel,
  n as StyledRadioHelperText
};
//# sourceMappingURL=styles49.mjs.map
